<script setup>
import DocumentGroupForm from '@frontJs/components/forms/projectManagement/DocumentGroupForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { documentGroup, nextPosition } = defineProps({
    documentGroup: {
        type: [Object, null],
        required: false,
    },
    nextPosition: {
        type: Number,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="documentGroup">
            Mettre à jour le groupe de documents #{{ documentGroup.id }} -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un groupe de documents - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="documentGroup">
        Gestion de projet - Mettre à jour le groupe de documents #{{
            documentGroup.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Créer un groupe de documents
    </PageTitle>

    <DocumentGroupForm
        :document-group="documentGroup"
        :next-position="nextPosition"
    />
</template>
